const BiFormatTaskAndBoltAxis = (torqueData) => {
  return {
    type: 'category',
    data: torqueData.map(item => item.taskAndBolt),
  };
};

export default BiFormatTaskAndBoltAxis;
